import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "#3152E6",
      "clip-path": "url(#i-1179421274__a)"
    }, [
      _createElementVNode("path", { d: "M12.615 28.987a10.01 10.01 0 0 0 12.618-.475.455.455 0 0 0 .023-.668l-4.12-4.12a1.5 1.5 0 0 0-2.176.058l-1.588 1.765A16.1 16.1 0 0 1 7.5 15.675l1.765-1.588a1.5 1.5 0 0 0 .058-2.176L5.216 7.804a.47.47 0 0 0-.693.023 9.99 9.99 0 0 0-.482 12.606 45.6 45.6 0 0 0 8.574 8.554M15.468 16h3.5l2.62 3.057a.5.5 0 0 0 .76 0L24.968 16h3.5a1.5 1.5 0 0 0 1.5-1.5v-12a1.5 1.5 0 0 0-1.5-1.5h-13a1.5 1.5 0 0 0-1.5 1.5v12a1.5 1.5 0 0 0 1.5 1.5m6.5-2.25a.75.75 0 0 1 0-1.5.75.75 0 0 1 0 1.5m-1.5-9.5h2.5a2.25 2.25 0 0 1 2.25 2.25v1a2.28 2.28 0 0 1-2.5 2.25c.17 1.166-1.395 1.395-1.5.25V9a.75.75 0 0 1 .75-.75h1a.75.75 0 0 0 .75-.75v-1a.75.75 0 0 0-.75-.75h-2.5a.75.75 0 0 1 0-1.5" })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "i-1179421274__a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 0h32v32H0z"
        })
      ])
    ], -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "callQuestion"}) } }